
import { Vue, Options } from 'vue-class-component';

@Options({
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    alert: {
      type: Boolean,
      default: false
    },
    target: {
      type: String
    }
  }
})
export default class CopdMeasurementRow extends Vue {
  //
}
